import React, { useState } from "react";
import { useHistory } from "react-router-dom";

import "./style.css";

const EgovServicesBox = () => {
  const history = useHistory();

  const [services, setServices] = useState([
    // {
    //   name: "UTI PAN",
    //   image: "/images/uti-logo.png",
    //   href: "/user/utiitsl_pancard",
    // },
    {
      name: "NSDL PAN",
      image: "/images/nsdl-logo.png",
      href: "/user/nsdl_pancard",
    },
    {
      name: "UTI PAN V2",
      image: "/images/uti-logo.png",
      href: "/user/utiitsl_pancard_v2",
    },
    {
      name: "KNOW YOUR PAN",
      image: "/images/pan-card-logo.png",
      href: "/user/find_pan_number",
    },
  ]);

  const navigate = (path) => {
    history.push(path);
  };

  return (
    <React.Fragment>
      <div className="dash-serviceBoxTitle">e-Governance</div>
      <div className="row pt-2">
        {services.map((value, key) => (
          <div className="col-sm-2">
            <div className="card">
              <div
                className="dash-serviceBox"
                onClick={() => {
                  navigate(value.href);
                }}
              >
                <div className="service-image">
                  <a href>
                    <img
                      className="img-thumbnail rounded-circle avatar-md"
                      alt="logo"
                      src={value.image}
                    />
                  </a>
                </div>
                <div className="service-content">
                  <h6 style={{ color: "black" }}>{value.name}</h6>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </React.Fragment>
  );
};

export default EgovServicesBox;
